import { Drawer, Form, Input, Select, DatePicker, Button, message } from "antd";
import { useEffect, useState } from "react";
import "react-quill-new/dist/quill.snow.css";

import {
  addDoc,
  updateDoc,
  doc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "@/firebaseConfig.js";
import dayjs from "dayjs";

const TransactionDrawer = ({
  visible,
  onClose,
  users,
  record,
  mode,
  onSaved,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === "edit" && record) {
      const user = users[record.userId];

      form.setFieldsValue({
        userId: record.userId,
        accountDetails: user?.accountDetails || "",
        amount: record.amount,
        status: record.status,
        paymentDate: record.paymentDate
          ? dayjs(new Date(record.paymentDate.seconds * 1000))
          : null,
      });
    } else {
      form.resetFields();
    }
  }, [record, mode, users, form]);

  const handleUserChange = (userId) => {
    form.setFieldsValue({
      accountDetails: users[userId]?.accountDetails || "",
    });
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const values = await form.validateFields();

      // 1️⃣ обновляем / создаём транзакцию
      const transactionData = {
        userId: values.userId,
        userEmail: users[values.userId]?.email || "",
        amount: Number(values.amount),
        status: values.status,
        paymentDate: values.paymentDate.toDate(),
      };

      if (mode === "edit" && record) {
        await updateDoc(doc(db, "paymentCalendar", record.id), transactionData);
        message.success("Transaction successfully updated");
      } else {
        await addDoc(collection(db, "paymentCalendar"), {
          ...transactionData,
          createdAt: serverTimestamp(),
        });
        message.success("Transaction successfully added");
      }

      // 2️⃣ обновляем реквизиты пользователя
      await updateDoc(doc(db, "users", values.userId), {
        accountDetails: values.accountDetails,
      });

      onSaved();
      onClose();
    } catch (error) {
      console.error(error);
      message.error("Failed to save the transaction");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={mode === "edit" ? "Edit Transaction" : "Add Transaction"}
      width={400}
      onClose={onClose}
      open={visible}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button loading={loading} type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item label="User" name="userId" rules={[{ required: true }]}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder="Select user"
            options={Object.values(users).map((u) => ({
              label: u.email,
              value: u.uid,
            }))}
            onChange={handleUserChange}
          />
        </Form.Item>

        <Form.Item
          label="Account Details"
          name="accountDetails"
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>

        <Form.Item label="Amount" name="amount" rules={[{ required: true }]}>
          <Input type="number" />
        </Form.Item>

        <Form.Item label="Status" name="status" rules={[{ required: true }]}>
          <Select
            options={[
              { label: "Pending", value: "PENDING" },
              { label: "Approved", value: "APPROVED" },
              { label: "Reject", value: "REJECT" },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Payment Date"
          name="paymentDate"
          rules={[{ required: true }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TransactionDrawer;
